module.exports = __webpack_public_path__ + "static/media/prettypoof.892e07b4.gif";